import { Brand, Neutrals } from './colors';

export const Overlay = {
  OverlayColorModale: `${Neutrals.neutralGreys.GreyNatural850}B8`,
  OverlayColorTileSelected: `${Neutrals.main.White}52`,
  OverlayColorDragAndDrop: `${Brand.water.Water500}33`,
};
